import React, { useState } from "react";
import { connect } from "react-redux";
import { translation } from 'helpers/utilsHelper.js';
import S from "StyledMultiCouponHistory.js";

const MultiCouponHistory = ({ transactionId, combinations = [], cashoutsMultiCoupon, openCashoutModal, children }) => {
  const [expandedItems, setExpandedItems] = useState(new Set());
  const isExpanded = (combinationId) => expandedItems.has(combinationId);
  const toggleExpandedItem = (combinationId) => {
    setExpandedItems((state) => {
      const newState = new Set(state);
      newState.has(combinationId)
        ? newState.delete(combinationId)
        : newState.add(combinationId);
      return newState;
    });
  }

  const getTransactionDetailsStatus = (statusCode) => {
    switch (statusCode) {
      default:
      case 0:
        return 'details_placed';
      case 1:
        return 'details_placed';
      case 2:
        return 'details_won';
      case 3:
        return 'details_lost';
      case 4:
      case 10:
        return 'details_cancel';
      case 5:
        return 'details_cashouted';
    }
  }

  const checkCashoutMultiCoupon = (combinationId) => {
    return cashoutsMultiCoupon[transactionId]?.combinationIds.has(combinationId) ?? false;
  };

  if (combinations.length === 0) {
    return null;
  }

  return (
    <S.MultiCouponWrapper>
      <S.MultiCouponBlockLabelWrapper>
        <S.MultiCouponBlockLabelSeparator />
        <S.MultiCouponBlockLabelStake>{translation('account_betHistory_stake')}</S.MultiCouponBlockLabelStake>
        <S.MultiCouponBlockLabelWin>{translation('account_betHistory_win')}</S.MultiCouponBlockLabelWin>
      </S.MultiCouponBlockLabelWrapper>

      {combinations.map(({ combinationId, stake, confirmedReturn, status, cashoutCommisionAmount = 0 }) => {
        const statusResult = getTransactionDetailsStatus(status);
        const confirmedWin = confirmedReturn - (cashoutCommisionAmount ?? 0);
        return (
          <S.MultiCouponBlockWrapper key={combinationId}>
            <S.MultiCouponBlockHeaderWrapper onClick={() => toggleExpandedItem(combinationId)}>
              <S.MultiCouponBlockHeaderTypeWrapper>
                <S.StatusIcon className={`item-icon ${statusResult}`}></S.StatusIcon>
                <S.MultiCouponBlockHeaderTypeLabel>{translation("betSlip_type_ACCUMULATOR")}</S.MultiCouponBlockHeaderTypeLabel>
              </S.MultiCouponBlockHeaderTypeWrapper>
              <S.MultiCouponBlockHeaderInfoStake>{stake.toFixed(2)} {translation('common_pln')}</S.MultiCouponBlockHeaderInfoStake>
              <S.MultiCouponBlockHeaderInfoWin>{confirmedWin.toFixed(2)} {translation('common_pln')}</S.MultiCouponBlockHeaderInfoWin>
              <S.MultiCouponBlockHeaderInfoExpand isExpanded={isExpanded(combinationId)} />
            </S.MultiCouponBlockHeaderWrapper>

            {isExpanded(combinationId) ? (
              <>
                {children}
                {checkCashoutMultiCoupon(combinationId) && (
                  <S.CashoutButton onClick={(e) => openCashoutModal(e, transactionId, combinationId)}>
                    {translation('account_betHistoryTransactionItem_detailsCashout')} {cashoutsMultiCoupon[transactionId].amount}&nbsp;{translation('common_pln')}
                  </S.CashoutButton>
                )}
              </>
            ) : null}
          </S.MultiCouponBlockWrapper>
        )
      })}
    </S.MultiCouponWrapper>
  )
}

const mapStateToProps = ({ AccountBetHistory: { cashoutsMultiCoupon } }) => {
  return {
    cashoutsMultiCoupon
  }
}

export default connect(mapStateToProps, null)(MultiCouponHistory);